import {
    MONTH_DAY_YEAR_DATE_FORMAT,
    YEAR_MONTH_DAY_DATE_FORMAT,
} from '../../../../../utils/constants/Common';

export const moveTypeRecordTypes = {
    RECEIVE: 'Receive',
    MOVE: 'Move',
    REALIZER: 'Realizer',
    MORTALITY: 'Mortality',
    SHIP: 'Ship',
};

export const showFeedDistributionWarningsKey = 'showFeedDistributionWarnings';

export const internalDateFormat = YEAR_MONTH_DAY_DATE_FORMAT;
export const displayDateFormat = MONTH_DAY_YEAR_DATE_FORMAT;
